import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const blogs = {
  namespaced: true,
  state: {
    blogsList: [],
    tags: [],
    categories: [],
    blogDetails: {},
    blog: {},
  },
  getters: {
    getBlogsList (state) {
      return state.blogsList;
    },
    getTags (state) {
      return state.tags;
    },
    getCategories (state) {
      return state.categories;
    },
    getBlogDetails (state) {
      return state.blogDetails;
    },
    getBlog (state) {
      return state.blog;
    },
  },
  mutations: {
    setBlogsList (state, data) {
      state.blogsList = data;
    },
    setTags (state, data) {
      state.tags = data;
    },
    setCategories (state, data) {
      state.categories = data;
    },
    setBlogDetails (state, data) {
      state.blogDetails = data;
    },
    setBlog (state, data) {
      state.blog = data;
    },
  },
  actions: {
    async fetchBlogsList ({ dispatch, commit }, payload) {
      const url = '/blogs';
      try {
        const response = await axios.get(url, payload);
        commit('setBlogsList', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the blogs list',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async createBlog ({ dispatch, commit }, payload) {
      const url = '/blogs';
      try {
        const response = await axios.post(url, payload);
        commit('setBlog', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in creating the blog',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async updateBlog ({ dispatch }, payload) {
      const url = `/blogs/${payload.id}`;
      try {
        await axios.put(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in updating the blog',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async deleteBlog ({ dispatch }, payload) {
      const url = `/blogs/${payload.id}`;
      try {
        await axios.delete(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in deleting the blog',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchTags ({ commit, dispatch }, payload) {
      const url = `/tags/${payload.resourceType}`;
      try {
        const response = await axios.get(url);
        commit('setTags', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the tags list',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async createTag ({ dispatch }, payload) {
      const url = '/tags';
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in creating the tags list',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async createCategory ({ dispatch }, payload) {
      const url = '/blogs/categories';
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in creating the Category',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchCategories ({ commit, dispatch }, payload) {
      const url = `/blog-categories/${payload.resourceType}`;
      try {
        const response = await axios.get(url);
        commit('setCategories', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the Categories list',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async deleteCategory ({ dispatch }, payload) {
      const url = `/blogs/categories/${payload.id}`;
      try {
        await axios.delete(url);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in deleting category',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchBlogDetails ({ dispatch, commit }, payload) {
      const url = `/blogs/${payload.id}`;
      try {
        const response = await axios.get(url);
        commit('setBlogDetails', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the blog details',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async uploadFile ({ dispatch }, payload) {
      const url = `/blogs/${payload.id}/upload`;
      try {
        await axios.post(url, payload.documentDetails);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in uploading feature image',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async publishBlog ({ dispatch }, payload) {
      const url = `blogs/${payload.id}/publish`;
      try {
        await axios.put(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in publishing blog',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async deleteTag ({ dispatch }, payload) {
      const url = `/tags/${payload.id}`;
      try {
        await axios.delete(url);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in deleting tag',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async deleteBlogTag ({ dispatch }, payload) {
      const url = `blogs/${payload.blogId}/tags/${payload.tagId}`;
      try {
        await axios.delete(url);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in deleting tag',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async removeBlogPdf ({ dispatch }, payload) {
      const url = `document-files/${payload.id}`;
      try {
        await axios.delete(url);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in deleting Ebook',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
  },
};
